// tslint:disable: completed-docs
import {addTrackingToAction} from '@vfde-sails/tracking';
import {createTrackingApplyFilter} from 'Container/Tracking/helper/createTrackingApplyFilterHelper';
import {
    TRACK_ACCORDION_OPEN,
    TRACK_ACCORDION_OPEN_SUCCESS,
    TRACK_APPLY_FILTER,
    TRACK_APPLY_FILTER_SUCCESS,
    TRACK_HOTLINE_CTA_CLICK,
    TRACK_FAQ_ACCORDION_OPEN,
    TRACK_PAGE_VIEW,
    TRACK_ERROR_JSON_NOT_FOUND,
    TRACKING_ERROR_NOT_FOUND_TYPE,
    TRACKING_ERROR_NOT_FOUND_MESSAGE,
} from 'Container/Tracking/constant';
import {createTrackingAccordionOpen} from 'Container/Tracking/helper/createTrackingAccordionOpenHelper';
import {createTrackingPageView} from 'Container/Tracking/helper/createTrackingPageViewHelper';
import {
    ACCORDION_OPENED,
    HOTLINE_BUTTON_CLICK,
} from 'Container/Landingpage/constant';
import {createTrackHotlineCTA_Click} from 'Container/Tracking/helper/createTrackingHotlineCTAClickHelper';
import {createTrackingFaqAccordionOpen} from 'Container/Tracking/helper/createTrackingFaqAccordionOpenHelper';

/**
 * Event, when Accordion is opened
 */
export const accordionOpened = (offerId) => {
    return {
        type: ACCORDION_OPENED,
        offerId,
    };
};

/**
 * Event, when Button in OfferPrice is clicked
 */
export const buttonOfferPriceClick = (phoneNumber) => {
    return {
        type: HOTLINE_BUTTON_CLICK,
        phoneNumber,
    };
};

/**
 * tracks, when the offer details get into viewport for the
 * first time, when the multipicker selection changes, the
 * "first time" will be reset
 * @param trackingData
 */
export function trackApplyFilter (offerId: string) {
    const trackingPayload = createTrackingApplyFilter(offerId);

    return addTrackingToAction(
        {
            type: TRACK_APPLY_FILTER,
        },
        'filter products',
        trackingPayload,
    );
}
export const trackApplyFilterSuccess = (offerId) => {
    return {
        type: TRACK_APPLY_FILTER_SUCCESS,
        offerId,
    };
};

/**
 * tracks click in accordion
 * @param trackingData
 */
export function trackAccordionOpened (trackingData) {
    const trackingPayload = createTrackingAccordionOpen(trackingData);

    return addTrackingToAction(
        {
            type: TRACK_ACCORDION_OPEN,
        },
        'in-page interaction',
        trackingPayload,
    );
}
export const trackAccordionOpenedSuccess = (offerId) => {
    return {
        type: TRACK_ACCORDION_OPEN_SUCCESS,
        offerId,
    };
};

/**
 * tracks click in accordion
 * @param trackingData
 */
export function trackHotlineCTA_Click (phoneNumber) {
    const trackingPayload = createTrackHotlineCTA_Click(phoneNumber);

    return addTrackingToAction(
        {
            type: TRACK_HOTLINE_CTA_CLICK,
        },
        'hotline cta',
        trackingPayload,
    );
}

/**
 * tracks the pageview when tha page is loaded
 * @param trackingData
 */
export function trackPageView (trackingData) {
    const trackingPayload = createTrackingPageView(trackingData);

    return addTrackingToAction(
        {
            type: TRACK_PAGE_VIEW,
        },
        'pageview',
        trackingPayload,
    );
}

/**
 * tracks the pageview when tha page is loaded
 * @param trackingData
 */
export function trackFaqAccordionToggle (accordionItemId) {
    const trackingPayload = createTrackingFaqAccordionOpen(accordionItemId);

    return addTrackingToAction(
        {
            type: TRACK_FAQ_ACCORDION_OPEN,
        },
        'reveal information',
        trackingPayload,
    );
}

/**
 * Track if JSON is not valid
 */

export const trackJsonNotValid = (trackingData) => {
    const trackingPayload = createTrackingPageView(trackingData);

    const errorObj = {
        type: TRACKING_ERROR_NOT_FOUND_TYPE,
        message: TRACKING_ERROR_NOT_FOUND_MESSAGE,
        code: '',
        location: '',
    };
    trackingPayload.error = errorObj;

    return addTrackingToAction(
        {
            type: TRACK_ERROR_JSON_NOT_FOUND,
        },
        'pageview',
        trackingPayload,
    );
};
